import { render } from "./OneTimeQrCode.vue?vue&type=template&id=5bc6d97c"
import script from "./OneTimeQrCode.vue?vue&type=script&lang=js"
export * from "./OneTimeQrCode.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__